import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Topbar from "../topbar/topbar";
import Sidebar from "../sidebar/sidebar";
import Footer from "../footer/footer";
import moment from "moment";
import "./tickets.css";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { logoutUser } from "./../../redux/actions/user";
import { withAuth } from "../withAuth";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import ReactPaginate from 'react-paginate';
import CustomTimer from "../../utils/timer";
import { connect } from "react-redux";
import {
    ticketList,
    companyList,
    ticketsByCompany,
    reassignTicketByRequester,
    launchTimer,
    filterOrdersList,
    stopTimer,
    paginatedTicketsList,
    ticketSearch,
    getTicketCount,
    getTicketDashCount,
    filterTicketsByStatus,
    clearSearchResults
} from "./../../redux/actions/ticket";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.core.css";
import { isEmpty } from "lodash";

// ========================
// LinkFormatter Component
// ========================
class LinkFormatter extends Component<{ row: any }, {}> {
    render() {
        const { row } = this.props;
        return (
            <div>
                <Link
                    to={`/edit-ticket/${row.id}`}
                    title="Edit Ticket"
                    className="btn btn-outline-primary"
                >
                    {row.id}
                </Link>
            </div>
        );
    }
}
function linkFormatter(cell: any, row: any) {
    return <LinkFormatter row={row} />;
}

// ========================
// ReAssign Component
// ========================
class ReAssign extends Component<
    { row: any; reassignTicketByRequester: (data: any) => void },
    { re_assign_reason: string }
> {
    constructor(props: any) {
        super(props);
        this.state = {
            re_assign_reason: "",
        };
    }

    handleSaveBtnClick = () => {
        const { row } = this.props;
        let ticketDate = moment().utc(false).format("YYYY-MM-DD HH:mm:ss");
        let requester = {
            id: sessionStorage.userId,
            email: sessionStorage.email,
        };
        const data = {
            id: row.id,
            subject: row.subject,
            requester_id: requester,
            ticket_status_code: 2,
            assigned_time: ticketDate,
            resolved_time: "",
            work_note: "",
            closed_time: "",
            cronTime: "",
            isAssign: 1,
            isActive: 1,
            re_assign_reason: this.state.re_assign_reason,
        };
        this.props.reassignTicketByRequester(data);
    };

    myModules = {
        toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
            ["link", "image"],
            ["clean"],
        ],
    };

    handleReactQuillChange = (value: string) => {
        this.setState({ re_assign_reason: value });
    };

    render() {
        const { row } = this.props;
        let re_assign_reason = (row.re_assign_reason || "").replace(/(<([^>]+)>)/gi, "");
        let truncatedReason = re_assign_reason.slice(0, 14) + (re_assign_reason.length > 14 ? "..." : "");
        return (
            <div>
                {row.ticket_status_code === 3 || row.ticket_status_code === 5 ? (
                    <div>
                        <button
                            data-toggle="modal"
                            data-target={`#reAssignTicket${row.id}`}
                            className="btn btn-outline-primary"
                            title="ReOpen Ticket"
                        >
                            Re Open
                        </button>
                        <div
                            title="Re-Assign Ticket"
                            id={`reAssignTicket${row.id}`}
                            role="dialog"
                            className="modal fade text-left"
                        >
                            <div role="document" className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Re-Assign Ticket</h4>
                                        <button type="button" data-dismiss="modal" className="close">
                                            <span>×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-group">
                                                    <p>Are you sure, you want to Re-Assign this Ticket?</p>
                                                    <h5>Re-Assign Reason</h5>
                                                    <ReactQuill
                                                        modules={this.myModules}
                                                        theme="snow"
                                                        onChange={this.handleReactQuillChange}
                                                        placeholder="Reassign Ticket note goes here..."
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" data-dismiss="modal" className="btn btn-danger">
                                            Close
                                        </button>
                                        <button
                                            type="button"
                                            data-dismiss="modal"
                                            className="btn btn-primary"
                                            disabled={this.state.re_assign_reason === ""}
                                            onClick={this.handleSaveBtnClick}
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <p title={re_assign_reason}>{truncatedReason}</p>
                )}
            </div>
        );
    }
}
function reAssign(cell: any, row: any, props: any) {
    return <ReAssign row={row} reassignTicketByRequester={props.reassignTicketByRequester} />;
}

function storeName(cell: any) {
    return <span title={cell || "N/A"}>{cell || "N/A"}</span>;
}

function assigneeGroup(cell: any) {
    return <span title={cell || "N/A"}>{cell || "N/A"}</span>;
}

function formatTime(cell: any) {
    return cell && !isEmpty(cell)
        ? moment(cell).local().format("MMM Do YYYY | hh:mm:ss a")
        : 'N/A';
}

function ticketStatusFormat(cell: any, row: any) {
    const statusClasses: Record<number, string> = {
        1: "badge-received",
        2: "badge-assigned",
        3: "badge-success",
        4: "badge-paused",
        8: "badge-closed",
        9: "badge-resumed"
    };
    return (
        <span className={`badge ${statusClasses[row.ticket_status_code]} badge-font-padding`} title={cell}>
            {cell}
        </span>
    );
}

// ========================
// Main Ticket Component
// ========================
interface Props {
    tickets: any[];
    companies: any[];
    ticketsByCompany: (id: any) => void;
    requesterTicketList: any[];
    assigneeTicketList: any[];
    supervisorTicketList: any[];
    ticketsReceived: number;
    ticketsAssigned: number;
    ticketsResolved: number;
    ticketsPaused: number;
    ticketsClosed: number;
    ticketsTotal: number;
    supervisorTickets: () => void;
    reassignTicketByRequester: (data: any) => void;
    assigneeTickets: () => void;
    companyList: () => void;
    logoutUser: () => void;
    launchTimer: (history: any) => void;
    filteredOrders: any[];
    emptyFilteredOrder: any[];
    timerStatus: boolean;
    ticketsList: any[];
    pageCount: number;
    currentPage: number;
    loading: boolean;
    searchResults: any[];
    searchLoading: boolean;
    ticketSearch: (query: string) => void;
    filterOrdersList: (filteredArr: any) => void;
    stopTimer: () => void;
    paginatedTicketsList: (page: any) => void;
    history: any;
    roleId: any;
    ticketList: () => void;
    getTicketCount: () => void;
    ticketCount: number;
    getTicketDashCount: () => void;
    filterTicketsByStatus: (status_code: number, page: number) => void;
    clearSearchResults: () => void;
}

interface State {
    company: string;
    ticketSearch: string;
    isModalOpen: boolean;
    wasTimerActiveBeforeModal: boolean;
    initialDataLoaded: boolean;
    filteredByStatus: number | null;
    hasNewTicketsWhileHidden: boolean;
    notificationPermission: NotificationPermission;
}

class Ticket extends Component<Props, State> {
    private closeModal: HTMLButtonElement | null = null;
    private autoRefreshInterval: NodeJS.Timeout | null = null;
    private audioElement: HTMLAudioElement | null = null;

    constructor(props: Props) {
        super(props);
        this.state = {
            company: "",
            ticketSearch: "",
            isModalOpen: false,
            wasTimerActiveBeforeModal: false,
            initialDataLoaded: false,
            filteredByStatus: null,
            hasNewTicketsWhileHidden: false,
            notificationPermission: "default",
        };
        this.handleTimer = this.handleTimer.bind(this);
        this.handleInput = this.handleInput.bind(this);
        
        // Pre-create and preload audio element for better background playback
        this.audioElement = new Audio(process.env.PUBLIC_URL + "/assets/sound/ringtone.mp3");
        this.audioElement.preload = "auto";
        this.audioElement.load();
    }

    componentDidMount() {
        this.fetchData(0);
        this.props.getTicketCount();
        this.props.getTicketDashCount();
        this.startAutoRefresh()
        this.props.launchTimer(this.props.history);
        document.title = "SimplexServices | Tickets";

        if (!sessionStorage.getItem("ticketLength")) {
            sessionStorage.setItem("ticketLength", "0");
        }

        // Request notification permission
        this.requestNotificationPermission();

        // Prime audio for background playback - play silently on first user interaction
        this.primeAudioForBackgroundPlayback();

        // Add page visibility listener
        document.addEventListener("visibilitychange", this.handleVisibilityChange);

        $(document).on('show.bs.modal', '.modal', (e) => {
            const { timerStatus } = this.props;
            const modalId = $(e.target).attr('id');
            if (modalId !== "enableTimer") {
                if (timerStatus) {
                    this.setState({ isModalOpen: true, wasTimerActiveBeforeModal: true });
                    this.props.stopTimer();
                } else {
                    this.setState({ isModalOpen: true, wasTimerActiveBeforeModal: false });
                }
            }
        });

        $(document).on('hidden.bs.modal', '.modal', (e) => {
            const modalId = $(e.target).attr('id');
            const { wasTimerActiveBeforeModal } = this.state;
            if (modalId !== "enableTimer") {
                this.setState({ isModalOpen: false });
                if (wasTimerActiveBeforeModal) {
                    this.props.launchTimer(this.props.history);
                }
            }
        });
    }

    componentWillUnmount() {
        $(document).off('show.bs.modal');
        $(document).off('hidden.bs.modal');
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        if (this.autoRefreshInterval) {
            clearInterval(this.autoRefreshInterval);
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.state.isModalOpen) return;

        const { ticketCount: newCount } = this.props;
        const { ticketCount: oldCount } = prevProps;

        if (oldCount !== undefined && oldCount !== 0 && newCount > oldCount) {
            this.fetchData(0);
            this.props.getTicketDashCount();
            sessionStorage.setItem("ticketLength", newCount.toString());

            // Always try to play audio immediately, regardless of tab visibility
            this.playAudio();

            // Check if the page is currently hidden for notification and fallback
            if (document.hidden) {
                // Tab is not active - show browser notification and mark for later (in case audio was blocked)
                this.setState({ hasNewTicketsWhileHidden: true });
                this.showBrowserNotification(newCount - oldCount);
            }
        }
    }

    playAudio() {
        if (this.audioElement) {
            // Reset audio to start
            this.audioElement.currentTime = 0;
            
            // Attempt to play immediately
            const playPromise = this.audioElement.play();
            
            if (playPromise !== undefined) {
                playPromise.catch(e => {
                    if (["NotAllowedError", "NotSupportedError"].includes(e.name)) {
                        console.log("Audio playback blocked by browser - will play when tab is active");
                    } else {
                        console.log("Audio playback error:", e);
                    }
                });
            }
        }
    }

    // Handle page visibility changes
    handleVisibilityChange = () => {
        if (!document.hidden && this.state.hasNewTicketsWhileHidden) {
            // User returned to the tab and there were new tickets while they were away
            this.playAudio();
            this.setState({ hasNewTicketsWhileHidden: false });
        }
    };

    // Prime audio for background playback by playing muted audio on first user interaction
    primeAudioForBackgroundPlayback = () => {
        const enableAudio = () => {
            if (this.audioElement) {
                this.audioElement.muted = true;
                this.audioElement.play()
                    .then(() => {
                        this.audioElement!.pause();
                        this.audioElement!.currentTime = 0;
                        this.audioElement!.muted = false;
                        console.log("Audio context primed for background playback");
                    })
                    .catch(() => {
                        // Silently fail, will try again on next interaction
                    });
            }
            // Remove listeners after first successful interaction
            document.removeEventListener("click", enableAudio);
            document.removeEventListener("keydown", enableAudio);
            document.removeEventListener("touchstart", enableAudio);
        };

        // Listen for user interactions to prime the audio
        document.addEventListener("click", enableAudio, { once: true });
        document.addEventListener("keydown", enableAudio, { once: true });
        document.addEventListener("touchstart", enableAudio, { once: true });
    };

    // Request notification permission
    requestNotificationPermission = async () => {
        if ("Notification" in window) {
            try {
                const permission = await Notification.requestPermission();
                this.setState({ notificationPermission: permission });
            } catch (error) {
                console.log("Notification permission request failed:", error);
            }
        }
    };

    // Show browser notification
    showBrowserNotification = (newTicketsCount: number) => {
        if (
            "Notification" in window &&
            this.state.notificationPermission === "granted"
        ) {
            const notification = new Notification("New Ticket(s) Received", {
                body: `You have ${newTicketsCount} new ticket${newTicketsCount > 1 ? 's' : ''}!`,
                icon: process.env.PUBLIC_URL + "/logo192.png",
                badge: process.env.PUBLIC_URL + "/logo192.png",
                tag: "new-ticket",
                requireInteraction: false,
                silent: false,
            });

            notification.onclick = () => {
                window.focus();
                notification.close();
            };

            // Auto-close notification after 10 seconds
            setTimeout(() => {
                notification.close();
            }, 10000);
        }
    };

    // Auto-refresh every 30 seconds
    startAutoRefresh = () => {
        this.autoRefreshInterval = setInterval(() => {
            const { searchResults, timerStatus } = this.props;

            // If refresh (timer) is disabled or a modal is open, do nothing.
            if (!timerStatus || this.state.isModalOpen) {
                return;
            }

            // When refresh is enabled, clear applied filters and search,
            // and reload the default paginated ticket list.
            if (this.state.filteredByStatus !== null) {
                this.setState({ filteredByStatus: null }, () => {
                    this.props.paginatedTicketsList(0);
                });
            }

            if ((searchResults && searchResults.length > 0) || this.state.ticketSearch !== "") {
                this.setState({ ticketSearch: "" }, () => {
                    this.props.clearSearchResults();
                    this.renderTicketList();
                });
            }
        }, 30000); // 30 seconds
    };
    handleStoresInputChange = (e: any) => {
        const companyId = e?.value;
        this.setState({
            company: companyId || "",
            filteredByStatus: null,
            ticketSearch: ""
        });
        this.props.filterOrdersList([]); // Clear any client-side filter
        if (companyId) {
            this.props.ticketsByCompany(companyId);
        } else {
            this.fetchData(0);
        }
    };

    rowClassNameFormat(row: any) {
        return row.isAssign == 1 ? "td-column-function-even-example" : "";
    }

    // Filter tickets by status (calls backend)
    FilterbyStatus = (status_code: number) => {
        this.setState({
            filteredByStatus: status_code,
            ticketSearch: "",
            company: ""
        });

        // Clear client-side filters
        this.props.filterOrdersList([]);
        // Fetch from backend with page 0 (action converts to page 1)
        this.props.filterTicketsByStatus(status_code, 0);
    };

    handleTimer() {
        if (this.props.timerStatus === false) {
            this.props.launchTimer(this.props.history);
        } else {
            this.props.stopTimer();
        }
        this.closeModal?.click();
    }

    // Unified data fetcher
    fetchData = (page: number) => {
        const { filteredByStatus } = this.state;

        if (filteredByStatus !== null) {
            this.props.filterTicketsByStatus(filteredByStatus, page);
        } else if (this.state.ticketSearch) {
            this.props.ticketSearch(this.state.ticketSearch);
        } else {
            this.props.paginatedTicketsList(page);
        }
    };

    handlePageClick = (data: any) => {
        if (this.state.isModalOpen) return;
        window.scrollTo({ top: 300, behavior: 'smooth' });
        setTimeout(() => this.fetchData(data.selected), 50);
    };

    handleInput(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ ticketSearch: event.target.value });
    }

    handleSearchTickets = (event: React.FormEvent) => {
        event.preventDefault();
        this.setState({ filteredByStatus: null, company: "" });
        this.props.filterOrdersList([]);
        this.props.ticketSearch(this.state.ticketSearch);
    };

    renderTicketList() {
        const { filteredOrders, emptyFilteredOrder, searchResults, ticketsList } = this.props;
        const { ticketSearch } = this.state;

        const flattenTicket = (ticket: any) => {
            // Guard clause to handle undefined or null tickets
            if (!ticket) {
                return {
                    id: "",
                    subject: "",
                    description: "",
                    store_name: "N/A",
                    ticket_status_description: "N/A",
                    ticket_status_code: "",
                    ticket_priority_description: "N/A",
                    name: "N/A",
                    group_name: "N/A",
                    recieved_time: "",
                    assigned_time: "",
                    resolved_time: "",
                    closed_time: "",
                    priority_response: 0,
                    priority_resolution: 0,
                    ticket_Info: "",
                    re_assign_reason: "",
                    isAssign: 0,
                };
            }

            return {
                id: ticket.id || "",
                subject: ticket.subject || "",
                description: ticket.description || "",
                store_name: ticket.store?.name || "N/A",
                ticket_status_description: ticket.ticket_status_code?.ticket_status_description || "N/A",
                ticket_status_code: ticket.ticket_status_code?.ticket_status_code || "",
                ticket_priority_description: ticket.ticket_priority_code?.ticket_priority_description || "N/A",
                name: ticket.requester_id?.name || "N/A",
                group_name: ticket.group_id?.name || "N/A",
                recieved_time: ticket.recieved_time || "",
                assigned_time: ticket.assigned_time || "",
                resolved_time: ticket.resolved_time || "",
                closed_time: ticket.closed_time || "",
                priority_response: ticket.ticket_priority_code?.response_time || 0,
                priority_resolution: ticket.ticket_priority_code?.resolution_time || 0,
                ticket_Info: `${ticket.recieved_time || ""} → ${ticket.closed_time || ""}`,
                re_assign_reason: ticket.re_assign_reason || "",
                isAssign: ticket.isAssign || 0,
            };
        };

        const transformList = (list: any) => Array.isArray(list) ? list.map(flattenTicket) : [];

        // Priority order of data sources - ensure arrays are defined
        if (filteredOrders && filteredOrders.length > 0) return transformList(filteredOrders);
        if (emptyFilteredOrder && emptyFilteredOrder.length > 0) return transformList(emptyFilteredOrder);
        if (searchResults && searchResults.length > 0) return transformList(searchResults);

        // Always flatten ticketsList before returning
        return transformList(ticketsList);
    }

    renderTicketInfo = (cell: any, row: any) => {
        const formatDuration = (minutes: number) => {
            const days = Math.floor(minutes / (60 * 24));
            const hours = Math.floor((minutes % (60 * 24)) / 60);
            const mins = minutes % 60;
            let parts = [];
            if (days > 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);
            if (hours > 0) parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
            if (mins > 0 || parts.length === 0) parts.push(`${mins} min${mins > 1 ? 's' : ''}`);
            return parts.join(' ');
        };

        const formatTimeDuration = (fromTime: any, toTime: any) => {
            if (!fromTime || !toTime || isEmpty(fromTime) || isEmpty(toTime)) {
                return 'N/A';
            }
            const duration = moment.duration(moment(toTime).diff(moment(fromTime)));
            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const mins = duration.minutes();
            const secs = duration.seconds();
            
            let parts = [];
            if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
            if (hours > 0) parts.push(`${hours} hr${hours !== 1 ? 's' : ''}`);
            if (mins > 0) parts.push(`${mins} min${mins !== 1 ? 's' : ''}`);
            if (secs > 0 || parts.length === 0) parts.push(`${secs} sec${secs !== 1 ? 's' : ''}`);
            
            return parts.join(' ');
        };

        const modalId = `ticketTimeModal${row.id}`;
        return (
            <div>
                <button
                    className="btn btn-outline-primary btn-sm"
                    data-toggle="modal"
                    data-target={`#${modalId}`}
                >
                    Time Info
                </button>
                <div id={modalId} className="modal fade" role="dialog">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-lg">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title m-0">Ticket Time Details</h5>
                            </div>
                            <div className="modal-body px-4 py-3">
                                {/* SLA Status Section */}
                                <h6 className="mb-3 text-primary font-weight-bold">SLA Status</h6>
                                <table className="table table-bordered table-hover table-striped">
                                    <thead className="thead-light">
                                        <tr>
                                            <th style={{ width: '30%' }}>Time Type</th>
                                            <th style={{ width: '55%' }}>Duration</th>
                                            <th style={{ width: '15%' }}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>Response Time</strong></td>
                                            <td>
                                                {row.assigned_time
                                                    ? formatTimeDuration(row.recieved_time, row.assigned_time)
                                                    : "N/A"}
                                            </td>
                                            <td>
                                                {row.assigned_time && (
                                                    <span className={`badge badge-${moment(row.assigned_time).diff(moment(row.recieved_time), "minutes") <= row.priority_response ? "success" : "danger"}`}>
                                                        {moment(row.assigned_time).diff(moment(row.recieved_time), "minutes") <= row.priority_response ? "Met" : "Breach"}
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>Resolution Time</strong></td>
                                            <td>
                                                {row.resolved_time
                                                    ? formatTimeDuration(row.recieved_time, row.resolved_time)
                                                    : "N/A"}
                                            </td>
                                            <td>
                                                {row.resolved_time && (
                                                    <span className={`badge badge-${moment(row.resolved_time).diff(moment(row.recieved_time), "minutes") <= row.priority_resolution ? "success" : "danger"}`}>
                                                        {moment(row.resolved_time).diff(moment(row.recieved_time), "minutes") <= row.priority_resolution ? "Met" : "Breach"}
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="modal-footer bg-light">
                                <button
                                    type="button"
                                    className="btn btn-danger font-weight-bold px-4 py-2"
                                    data-dismiss="modal"
                                >
                                    Close 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            ticketsList,
            pageCount,
            currentPage,
            loading,
            searchResults,
            searchLoading,
            ticketsReceived,
            ticketsAssigned,
            ticketsResolved,
            ticketsPaused,
            ticketsClosed,
            ticketsTotal,
            timerStatus,
            roleId,
        } = this.props as any;

        const hasReopenAccess = roleId === "1" || roleId === "3" || roleId === 1 || roleId === 3;

        const ticketDescription = (desc: string) => {
            if (!desc) return <div className="custom-text-editor-text" title="">-</div>;
            const plainText = desc.replace(/(<([^>]+)>)/gi, "");
            const truncated = plainText.length > 28 ? plainText.substring(0, 25) + "..." : plainText;
            return (
                <div className="custom-text-editor-text" title={plainText}>
                    {truncated}
                </div>
            );
        };

        const options = {
            sizePerPage: 20,
            pageStartIndex: 1,
            paginationSize: 3,
            hideSizePerPage: true,
            noDataText: "Tickets Not Found",
        };

        return (
            <div className="page">
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">

                        <header className="page-header py-0">
                            <div className="container-fluid">
                                <div className="d-flex align-items-center py-3">
                                    <h4 className="mt-0 mb-0 d-flex align-items-center">
                                        Ticket Management
                                        <button
                                            title={timerStatus ? "Disable Refresh" : "Enable Refresh"}
                                            data-toggle="modal"
                                            data-target="#enableTimer"
                                            className={`btn ${timerStatus ? "btn-outline-danger" : "btn-outline-success"} ml-2`}
                                        >
                                            <i className="fa fa-refresh"></i>
                                        </button>
                                        <span className="ml-3"><CustomTimer /></span>
                                    </h4>
                                </div>
                            </div>
                        </header>

                        <section className="dashboard-counts py-2">
                            <div className="container-fluid">
                                <div className="row bg-white has-shadow p-0">
                                    {[
                                        { status: 1, icon: "fa-get-pocket", color: "bg-violet", label: "Received", count: ticketsReceived },
                                        { status: 2, icon: "fa-users", color: "bg-red", label: "Assigned", count: ticketsAssigned },
                                        { status: 3, icon: "fa-unlock-alt", color: "bg-orange", label: "Resolved", count: ticketsResolved },
                                        { status: 4, icon: "fa-pause", color: "bg-yellow", label: "Paused", count: ticketsPaused },
                                        { status: 8, icon: "fa-window-close", color: "bg-green", label: "Closed", count: ticketsClosed },
                                        { status: 0, icon: "fa-calculator", color: "bg-green", label: "Total", count: ticketsTotal }
                                    ].map((item, index) => (
                                        <div className="col-xl-2 col-sm-6" key={index}>
                                            <div
                                                onClick={() => this.FilterbyStatus(item.status)}
                                                className="item d-flex align-items-center"
                                                style={{ border: "none", cursor: "pointer" }}
                                            >
                                                <div className={`icon ${item.color}`}>
                                                    <i className={`fa ${item.icon}`}></i>
                                                </div>
                                                <div className="title">
                                                    <span>{item.label}</span>
                                                    <br />
                                                    <strong className="text-bold text-dark">{item.count}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>

                        <section className="tables py-2 tickets-list">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col">
                                        <div className="card">
                                            <div className="card-body theme-swither">
                                                <div className="col-md-12 col-sm-6 col-12">
                                                    <div className="row">
                                                        <div className="col-md-10 col-12">
                                                            <div className="form-group">
                                                                <input id="TicketId" type="text" onWheel={(e: any) => e.target.blur()} value={this.state.ticketSearch} name="ticketId" required placeholder="Search With Ticket ID" className="input-material" onChange={this.handleInput} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 col-12 float-right mt-1">
                                                            <div className="form-group">
                                                                <button onClick={this.handleSearchTickets} disabled={this.state.ticketSearch == ""} className="btn btn-primary">Search Ticket</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {loading || searchLoading ? (
                                                    <BootstrapTable data={[{}, {}, {}, {}]} options={options} pagination>
                                                        {[...Array(13)].map((_, i) => (
                                                            <TableHeaderColumn
                                                                key={i}
                                                                dataField={`col${i}`}
                                                                isKey={i === 0}
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                <Skeleton height={20} width={70} />
                                                            </TableHeaderColumn>
                                                        ))}
                                                    </BootstrapTable>
                                                ) : (
                                                    <>
                                                        <BootstrapTable
                                                            data={this.renderTicketList()}
                                                            pagination={ticketsList.length > 10 || this.state.filteredByStatus !== null}
                                                            trClassName={this.rowClassNameFormat}
                                                            options={options}
                                                            exportCSV
                                                            csvFileName="tickets.csv"
                                                            hover
                                                            search
                                                            searchPlaceholder="Search tickets..."
                                                        >
                                                            {hasReopenAccess && (
                                                                <TableHeaderColumn
                                                                    dataField="re_assign_reason"
                                                                    dataFormat={reAssign}
                                                                    formatExtraData={this.props}
                                                                    width="120"
                                                                    thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                    tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                                >
                                                                    Re Open
                                                                </TableHeaderColumn>
                                                            )}
                                                            <TableHeaderColumn
                                                                dataField="id"
                                                                isKey
                                                                dataFormat={linkFormatter}
                                                                width="100"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Ticket Id
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="subject"
                                                                width="150"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Subject
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="description"
                                                                dataFormat={ticketDescription}
                                                                width="200"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Issue Description
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="store_name"
                                                                dataFormat={storeName}
                                                                width="130"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Store
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="ticket_status_description"
                                                                dataFormat={ticketStatusFormat}
                                                                width="130"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Ticket Status
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="ticket_priority_description"
                                                                width="130"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Ticket Priority
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="name"
                                                                width="150"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Requester Name
                                                            </TableHeaderColumn>
                                                            {/* <TableHeaderColumn
                                                                dataField="group_name"
                                                                dataFormat={assigneeGroup}
                                                                width="130"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Assignee  Group
                                                            </TableHeaderColumn> */}
                                                            <TableHeaderColumn
                                                                dataField="recieved_time"
                                                                dataFormat={formatTime}
                                                                width="200"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Recieved Time
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="assigned_time"
                                                                dataFormat={formatTime}
                                                                width="200"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Assigned Time
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="resolved_time"
                                                                dataFormat={formatTime}
                                                                width="200"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Resolved Time
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="closed_time"
                                                                dataFormat={formatTime}
                                                                width="200"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Closed Time
                                                            </TableHeaderColumn>
                                                            <TableHeaderColumn
                                                                dataField="ticket_Info"
                                                                dataFormat={this.renderTicketInfo}
                                                                width="200"
                                                                thStyle={{ fontSize: 12, fontWeight: "bold", textAlign: "center" }}
                                                                tdStyle={{ fontSize: 12, textAlign: "center" }}
                                                            >
                                                                Ticket Time
                                                            </TableHeaderColumn>
                                                        </BootstrapTable>

                                                        {this.renderTicketList().length > 0 && (!searchResults || !searchResults.length) && (
                                                            <ReactPaginate
                                                                previousLabel={currentPage !== 0 ? "<<" : ""}
                                                                nextLabel={currentPage < pageCount - 1 ? ">>" : ""}
                                                                breakLabel="..."
                                                                pageCount={pageCount}
                                                                onPageChange={this.handlePageClick}
                                                                containerClassName="pagination-container"
                                                                activeClassName="active"
                                                                pageRangeDisplayed={3}
                                                                marginPagesDisplayed={4}
                                                                forcePage={currentPage}
                                                                disableInitialCallback={true}
                                                            />
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>
                </div>

                {/* Timer Modal */}
                <div id="enableTimer" className="modal fade text-left">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Auto Refresh</h4>
                                <button type="button" data-dismiss="modal" className="close">
                                    <span>×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    Are you sure, you want to {timerStatus ? "disable" : "enable"} auto refresh?
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    ref={(el) => (this.closeModal = el)}
                                    data-dismiss="modal"
                                    className="btn btn-secondary"
                                >
                                    Close
                                </button>
                                <button onClick={this.handleTimer} className="btn btn-primary">
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => ({
    tickets: state.ticket.ticketList,
    companies: state.ticket.companies,
    ticketsReceived: state.ticket.ticketsReceived,
    ticketsAssigned: state.ticket.ticketsAssigned,
    ticketsResolved: state.ticket.ticketsResolved,
    ticketsPaused: state.ticket.ticketsPaused,
    ticketsClosed: state.ticket.ticketsClosed,
    ticketsTotal: state.ticket.ticketsTotal,
    filteredOrders: state.ticket.filteredOrders,
    emptyFilteredOrder: state.ticket.emptyFilterOrder,
    timerStatus: state.ticket.timerStatus,
    ticketsList: state.ticket.ticketsList,
    pageCount: state.ticket.pageCount,
    currentPage: state.ticket.currentPage,
    loading: state.ticket.loading,
    searchResults: state.ticket.searchResults,
    searchLoading: state.ticket.searchLoading,
    ticketCount: state.ticket.ticketCount
});

const mapDispatchToProps = {
    ticketList,
    ticketSearch,
    ticketsByCompany,
    companyList,
    reassignTicketByRequester,
    filterOrdersList,
    launchTimer,
    stopTimer,
    logoutUser,
    paginatedTicketsList,
    getTicketCount,
    getTicketDashCount,
    filterTicketsByStatus,
    clearSearchResults
};

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(Ticket));